var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import MuiSnackbarContent from '@material-ui/core/SnackbarContent';
import defaultTheme from '../palette';
var StyledSnackbarContent = styled(MuiSnackbarContent)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  && {\n    ", ";\n  }\n\n  & .MuiSnackbarContent-action button {\n    color: #fff;\n  }\n"], ["\n  && {\n    ",
    ";\n  }\n\n  & .MuiSnackbarContent-action button {\n    color: #fff;\n  }\n"])), function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return props.type === 'success'
        ? "background-color:" + (((_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.palette) === null || _b === void 0 ? void 0 : _b.success) === null || _c === void 0 ? void 0 : _c.main) || ((_d = defaultTheme === null || defaultTheme === void 0 ? void 0 : defaultTheme.success) === null || _d === void 0 ? void 0 : _d.main))
        : "background-color:" + (((_g = (_f = (_e = props === null || props === void 0 ? void 0 : props.theme) === null || _e === void 0 ? void 0 : _e.palette) === null || _f === void 0 ? void 0 : _f.primary) === null || _g === void 0 ? void 0 : _g.dark) || ((_h = defaultTheme === null || defaultTheme === void 0 ? void 0 : defaultTheme.primary) === null || _h === void 0 ? void 0 : _h.dark));
});
/**
 * Kareo wrapped component of the Material-UI SnackbarContent. The prop API has been limited to props defined in SnackbarContentProps.
 *
 * Material-UI SnackbarContent: [Docs](https://v4.mui.com/components/snackbars/), [API](https://v4.mui.com/api/snackbar-content/)
 *
 * @storybook: [Snackbar](http://design.kareoprod.ent/design-system/?path=/story/components-feedback-snackbar)
 */
var SnackbarContent = React.forwardRef(function (props, ref) {
    return React.createElement(StyledSnackbarContent, __assign({}, props, { ref: ref }));
});
SnackbarContent.defaultProps = {};
SnackbarContent.displayName = 'KareoSnackbarContent';
export default SnackbarContent;
var templateObject_1;
